import { call, put } from 'redux-saga/effects'

import { UpdateBlogInputInterface } from '../../../interfaces/blog'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { requestFailure, updateBlogSucceed } from '../actions'

export function* updateBlogSaga(
  blogApi: {
    updateBlog: (...args: any[]) => any
  },
  {
    payload: { blogId, blogDetail }
  }: {
    payload: {
      blogId: string
      blogDetail: UpdateBlogInputInterface
    }
  }
) {
  try {
    const { data } = yield call(blogApi.updateBlog, blogId, blogDetail)
    yield put(updateBlogSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
